module.exports = __webpack_public_path__ + "static/dcom2-300x177-399c29a8d542ded1a410807d32f61985.png";